import {Fragment, UUID} from '@nh/angular-tses';
import {DASFragmentType} from './das-fragment-type';

export enum IncorporationState {
  NOT_INCORPORATED = 'NOT_INCORPORATED',
  INCORPORATED = 'INCORPORATED',
  TO_BE_CONFIRMED = 'TO_BE_CONFIRMED',
  STATUS_WILL_NOT_BE_CONFIRMED = 'STATUS_WILL_NOT_BE_CONFIRMED',
}

/**
 * A class representing a Location Fragment used for displaying locational information.
 *
 * @field value {string}   The raw Location
 */
export class LocationFragment extends Fragment {
  /**
   * Static helper to return an empty location fragment.
   *
   * @returns {LocationFragment}   The location fragment
   */
  public static empty(): LocationFragment {
    return new LocationFragment(null, '', '', '', null);
  }

  constructor(
    id: UUID,
    title: string = '',
    public description: string = '',
    public gridRef: string = '',
    public structureKey: string = null,
    public incorporationState: IncorporationState = null,
    public dateIncorporated: number = null
  ) {
    super(id, DASFragmentType.LOCATION, [], title);
  }

  /**
   * @inheritDoc
   */
  public split(offset: number): LocationFragment {
    return null;
  }
}

/**
 * Deserialiser function for Location Fragments.
 *
 * @param json {any}                JSON object to deserialise
 * @returns    {LocationFragment}   Deserialised Location Fragment Object
 */
export function deserialiseLocationFragment(json: any): LocationFragment {
  return new LocationFragment(
    UUID.orThrow(json.id),
    json.value,
    json.description,
    json.gridRef,
    json.structureKey,
    json.incorporationState,
    json.dateIncorporated
  );
}
